import { gql } from '@apollo/client'

import { FRAGMENT as VIDEO_FRAGMENT } from '../../components/LibraryPostVideoCard'
import { FRAGMENT as ARTICLE_FRAGMENT } from '../../components/LibraryPostArticleCard'

export const PAGES = gql`
  query TopicPages {
    libraryTopics {
      id
      slug
    }
  }
`

export const TOPIC = gql`
  query Topic($slug: String!) {
    libraryTopic(slug: $slug) {
      id
      slug
      title
      color
    }
  }
`

export const POSTS = gql`
  query TopicPosts($topicSlug: String, $page: Int, $perPage: Int, $type: LibraryPostType) {
    libraryPosts(topicSlug: $topicSlug, page: $page, perPage: $perPage, type: $type) {
      nodes {
        ... on LibraryPostArticle {
          ...LibraryPostArticleCardComponent
        }
        ... on LibraryPostVideo {
          ...LibraryPostVideoCardComponent
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }

  ${VIDEO_FRAGMENT}
  ${ARTICLE_FRAGMENT}
`
